import { Config } from "../landing-config";
import { ico_picked } from "../map-config";


const maxFileRows = 500;
export const KIT_CONFIG: Config = {
    data: {
        route: 'kit',
        page_title: 'NNI Interconnection | Open Fiber',
        service_title: 'NNI Interconnection',
        service_description: '',
        service_name: '',
        service_slug: 'kit',
        errorTimeout: 0,
        feasibilityModelSingle: true,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziokit/massivep2p/detail',
                massiveUploadPath: '/serviziokit/massivep2p/upload',
                massiveDownloadPath: '/serviziokit/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/serviziokit/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/serviziokit/p2p',
			bboxPath: null,
			buildingSearchParams: null
        },
        dynamic_aend_name: 'KIT'
    },
    multiple_points: {
        variable: true,
        max: 1,
        points: {
            b_end: {
                default_method: 'poi',
                switch_methods: false,
                address: false,
                pop: true,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: false,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
                city_building: false,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: true,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            },
            a_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
                city_building: false,
                id_healthcare: false,
                upload: false,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            }
        },
        initial_points: ['b_end', 'a_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: false,
        marker_default_icon: ico_picked,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAB', 'CoveredCD', 'CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: true,
        click: true,
        loadCities: false
    },
    pop_ola: {
        load: false,
        view_initial: false,
        click: false
    },
    pcn: {
        load: true,
        view_initial: true,
        click: true
    },
    pop_agf: {
        load: true,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: true,
        click: true,
        x_pop: true,
        is_registered: true,
        custom_research_method: null,
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: false,
        click: false,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}
